import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';

const NotFound = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant='h5'>404 - Page Not Found</Typography>
      </CardContent>
    </Card>
  );
};

export default NotFound;
